"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var notistack_1 = require("notistack");
var react_1 = require("react");
var extractErrorMessage_1 = require("../../util/extractErrorMessage");
var useCurriedSnackbar = function () {
    var _a = (0, notistack_1.useSnackbar)(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    return {
        enqueueErrorSnack: (0, react_1.useCallback)(function (error, options) {
            return enqueueSnackbar((0, extractErrorMessage_1.extractErrorMessage)(error), __assign(__assign({}, options), { variant: 'error' }));
        }, [enqueueSnackbar]),
        enqueueWarningSnack: (0, react_1.useCallback)(function (message, options) { return enqueueSnackbar(message, __assign(__assign({}, options), { variant: 'warning' })); }, [enqueueSnackbar]),
        enqueueSuccessSnack: (0, react_1.useCallback)(function (message, options) { return enqueueSnackbar(message, __assign(__assign({}, options), { variant: 'success' })); }, [enqueueSnackbar]),
        closeSnackbar: closeSnackbar,
    };
};
var snackbarHooks = {
    useCurriedSnackbar: useCurriedSnackbar,
};
exports.default = snackbarHooks;
